export default __webpack_public_path__ + "static/media/club2020-logo.d60f52e4.svg";